import { useMemo } from "react";
import classNames from "classnames";
import styles from "./FrameTimestamp.module.scss";

export const createTimestampDisplay = (timestamp: number) => {
  const h = Math.floor(timestamp / 3600);
  const m = Math.floor((timestamp % 3600) / 60);
  const s = Math.floor(timestamp % 60);

  const paddedS = s.toString().padStart(2, "0");

  const paddedM = m.toString().padStart(2, "0");
  if (h > 0) {
    return `${h}:${paddedM}:${paddedS}`;
  }
  return `${paddedM}:${paddedS}`;
};

export const FrameTimestamp = ({
  timestamp,
  small,
}: {
  small?: boolean;
  timestamp: number;
}) => {
  const time = useMemo(() => createTimestampDisplay(timestamp), [timestamp]);
  return (
    <div
      className={classNames(styles.timestamp, {
        [styles.small]: small,
      })}
    >
      {time}
    </div>
  );
};
